import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IS_HYBRID_CART_ACTIVE, type RootState } from 'core';
import type { DataTracking } from 'core/middlewares/trackingGA4';
import { app, cart } from 'core';
import { HeaderCart } from 'ui/components';
import { useGetFeatureFlag } from 'ui/hooks';
import { addPageAction } from 'core/utilities';

const HeaderCartWidget = () => {
  const history = useHistory();
  const { trackClick } = app.commands.useAppCommand();

  const {
    data: { isBlocked: isUserBlocked, resellerId },
  } = useSelector((state: RootState) => state.user);
  const { value: isHybridCart } = useGetFeatureFlag(IS_HYBRID_CART_ACTIVE, false, resellerId);

  const handleTrackClick = (event: React.UIEvent<HTMLButtonElement, UIEvent>) => {
    const trackData = {
      eventAction: 'clique:header',
      eventCategory: 'geral',
      eventLabel: 'pedido',
    } as DataTracking;

    trackClick(event, 'event', trackData);
  };

  const handleClick = (event: React.UIEvent<HTMLButtonElement, UIEvent>) => {
    handleTrackClick(event);
    addPageAction('click-cart-button', { isCart20: isHybridCart, resellerId });

    history.push('/carrinho');
  };

  const {
    data: { totalUnitCount },
  } = cart.hooks.useCart();

  return (
    <HeaderCart cartItemCount={totalUnitCount} onClickCart={handleClick} disabled={isUserBlocked} />
  );
};

export default HeaderCartWidget;
